import classes from "./GNCCustomWellnessPlan.module.css";

const ROWS = [
  { label: "Exercise", color: "var(--secondary20)" },
  { label: "Nutrition", color: "var(--secondary10)" },
  { label: "Supplements", color: "var(--secondary40)" },
];

const GNCCustomWellnessPlan = () => {
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        __________________'s Custom Wellness Plan
      </div>
      <div className={classes.subTitle}>
        Athletic Recovery | Weight Management | Pain Management
      </div>
      <div className={classes.subTitle}>
        Proactive Wellness | Boost Immune System | Improve Focus/Mental Health
      </div>
      <table className={classes.table}>
        <tbody>
          {ROWS.map((row) => (
            <tr className={classes.row} key={row.label}>
              <td className={classes.iconCell}>
                <div
                  className={classes.iconCircle}
                  style={{ backgroundColor: row.color }}
                />
                <div className={classes.iconLabel}>{row.label}</div>
              </td>
              <td className={classes.contentCell} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GNCCustomWellnessPlan;
